
import React from 'react';
import { Table } from 'react-bootstrap';
import UserTableRow from './user_table_row';
import { StatDetails, StatHelpers } from './../../../lib/StatHelpers.js';
import Dropdown from './dropdown';

const chunks = (array, size=5) => {
  const clonedArray = [...array];
  const results = [];
  while (clonedArray.length) {
    const subArray = clonedArray.splice(0, size);
    for (let i = 0; i < (subArray.length % size); i += 1) {
      /*
       * In order to resize these buttons using flexbox
       * without having them stretch to fill empty space,
       * need to introduce padding elements
      */
      subArray.push(null);
    }
    results.push(subArray);
  }
  return results;
};

const rangeArray = (min, max, increment) => {
  let results = [];
  let i = min;
  while (i <= max) {
    results.push(i);
    i += increment;
  }
  return results;
};

class UserStats extends React.Component {
  dropdowns = () => {
    const dropdowns = [];
    const { gender } = this.props.profile.data;
    if (!gender) {
      return [];
    }
    let statIds = [];
    if (gender === 'Female') {
      statIds = [
        'height',
        'waist',
        'hip',
        'bust',
        'dress',
        'shoe',
        'ethnicity',
        'eye_color',
        'hair_color',
        'cup_size',
      ];
    } else {
      statIds = [
        'height',
        'chest',
        'waist',
        'shoe',
        'eye_color',
        'hair_color',
      ];
    }
    statIds.map((statId) => {
      const statDetails = StatDetails[gender][statId];
      let valueIds;
      if (statDetails.type === 'range') {
        valueIds = rangeArray(
          statDetails.min,
          statDetails.max,
          statDetails.increment,
        );
      } else if (statDetails.type === 'list') {
        valueIds = statDetails.values;
      }
      const valueLabels = valueIds.map((valueId) => {
        return StatHelpers.renderStat(valueId, statDetails.displayType);
      });
      dropdowns.push({
        id: statId,
        title: statDetails.title,
        valueIds,
        valueLabels,
      });
    });
    return dropdowns;
  }

  displayValueForDropdown = (id) => {
    const stats = this.props.profile.data;
    return StatHelpers.renderStat(stats[id], 'asIs');
  };

  handleChange = (id, value) => {
    this.props.changeStat(id, value);
  };

  render() {
    return (
      <Table striped bordered condensed style={{ marginLeft: '20px' }}>
        <tbody>
          <tr>
            <td>
          {
            chunks(this.dropdowns()).map(chunk => (
              <div style={{ flexDirection: 'row', display: 'flex'}}>
                {
                  chunk.map((dropdown, index) => {
                    if (dropdown) {
                      return (
                        <div style={{ flexDirection: 'column', display: 'flex' }}>
                          <div>
                            {' '}
                            {dropdown.title.toUpperCase()}{' '}
                          </div>
                          <div style={{ width: '100px', margin: '2px' }}>
                            <Dropdown
                              name={dropdown.id}
                              placeholder="TBD"
                              value={this.displayValueForDropdown(dropdown.id)}
                              ids={dropdown.valueIds}
                              displayedValues={dropdown.valueLabels}
                              onChange={(value) => {
                                this.handleChange(dropdown.id, value);
                              }}
                            />
                          </div>
                        </div>
                      );
                    }
                    return <div/>;
                  })
                }
              </div>
            ))
          }
          </td>
          </tr>
        </tbody>
      </Table>
    );
  }
};


export default UserStats;
